import Card from './../components/ServiceCard';
import Heading from './../components/Heading';
import SmallHeading from './../components/SmallHeading';
import DetailsHeading from './../components/DetailsHeading';
import Counsel from './../assets/Svgs/remote.svg'
import Contract from './../assets/Svgs/contract.svg'
import Compliance from './../assets/Svgs/risk.svg'
import Property from './../assets/Svgs/property.svg'
import HR from "../assets/Svgs/hr.svg"
import Privacy from './../assets/Svgs/privacy.svg'
import Transaction from './../assets/Svgs/transaction.svg'
import Operation from './../assets/Svgs/operation.svg'
import Legal from './../assets/Svgs/legal.svg'
import Document from './../assets/Svgs/document.svg'

function ServiceSection() {
  return (
    <section className='mb-10'>
    <SmallHeading name="Our Key Services" tstyle="text-center my-1 mt-10"/>
    <Heading name="Supporting Your Goals Every Step of the Way" tstyle="text-center my-1"/>
    <div className='mt-4 px-10' >
      <DetailsHeading 
      name="At PocketLPO, we offer flexible, cost-effective, and comprehensive legal solutions
       tailored to your business needs, with scalable services that you can access anytime, anywhere.
        Benefit from a wide range of expertise, from corporate governance to intellectual property management, all through our advanced platform." 
      tstyle="my-1"
      />

    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-10 mx-10">
      <Card
        heading="Remote In-House Counsel"
        image={Counsel}
        description='Act as an extension of your team with our dedicated legal experts, accessible anytime and anywhere.'
        linkText='remote-in-house-counsel'
      />
      <Card
        heading="Contract Drafting & Management"
        image={Contract}
        description='Simplify your contract processes with our drafting and management services to ensure your interests are protected.'
        linkText='contract-drafting-and-management'
      />
      <Card
        heading="Corporate Governance & Compliance"
        image={Compliance}
        description='Navigate regulatory landscapes confidently with our comprehensive compliance services, mitigating risks effectively.'
        linkText='corporate-governance-and-compliance'
      />
      <Card
        heading="Intellectual Property(IP) Services"
        image={Property}
        description='Safeguard your innovations with our IP management services, including trademark registration and portfolio management.'
        linkText='intellectual-property-services'
      />

      <Card
        heading="Litigation Support & E-Discovery"
        image={Document}
        description='Streamline your litigation process with our support services, including document review, e-discovery, and case summaries.'
        linkText='litigation-support-and-ediscovery'
      />
      <Card
        heading="HR Legal Support"
        image={HR}
        description='Ensure your HR practices are legally sound with PocketLPO’s HR Legal Support. We assist businesses in managing employment agreements, policies, and compliance requirements.'
        linkText='hr-legal-support'
      />
      <Card
        heading="Data Privacy & Protection Services"
        image={Privacy}
        description='Safeguard your business and customer data with PocketLPO’s Data Privacy & Protection services. We provide robust solutions to help you comply with global privacy laws and respond to data breaches effectively.'
        linkText='data-privacy-and-protection'
      />

      <Card
        heading="Mergers & Acquisitions(M&A) Legal Support"
        image={Transaction}
        description='Navigate the complexities of corporate transactions with PocketLPO’s M&A Support services. We provide strategic legal assistance to ensure your mergers, acquisitions, and restructurings are seamless.'
        linkText='mergers-and-acquisitions-legal-support'
      />
      <Card
        heading="Fixed Fee Legal Services"
        image={Legal}
        description='Provides predictable and transparent pricing for specific tasks. Ideal for businesses looking to manage costs without compromising on quality.'
        linkText='fixed-fee-legal'
      />
      <Card
        heading="Paralegal Services"
        image={Operation}
        description='Access professional paralegal support on demand with PocketLPO’s Paralegal Services. Our team ensures efficient assistance for your legal needs without the cost of full-time staff.'
        linkText='paralegal-service'
      />
    </div>
    </section>
  );
}

export default ServiceSection;
